<template>
  <div class="mode" :style="{ width: ImgWidth, height: ImgHeight }">
    <div class="bodySolt" :style="{ width: ImgWidth, height: ImgHeight }">
      <slot name="body"></slot>
    </div>

  </div>
</template>

<script>
export default {
  props: ['ImgWidth', "url", "ImgHeight"],
  name: 'WebEmptyView',
  data() {
    return {

    }
  },
  methods: {
    tabClickChen(index) {
      console.log("触发：", index);
    },
  }
}
</script>

<style scoped lang="scss">
.mode {

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  position: relative;
  top: 0;
  left: 0;
  width: 100%;
}
</style>